import React from 'react'
import { Grid, Link } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import Card from '../../shared/layout/Card'
import Paragraph from '../../shared/UI/Paragraph'
import { ManAuthRequestResponse } from '../../types/ManAuthRequests'
import { NO_APPROVER_ASSIGNED } from '../../utils/constants'

interface SummaryCardProps {
  manAuthRequest: ManAuthRequestResponse | null
  isManager: boolean | null | undefined
}

export default function SummaryCard({ manAuthRequest, isManager }: SummaryCardProps) {
  const navigate = useNavigate()
  const location = useLocation()

  const labelStyle = {
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '130%',
    letterSpacing: '0em',
    fontVariationSettings: '"opsz" auto',
    color: '#3D3D3D',
  }

  const valueStyle = {
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: '130%',
    letterSpacing: '0em',
    fontVariationSettings: '"opsz" auto',
    color: '#3D3D3D',
  }

  const linkStyle = {
    ...valueStyle,
    cursor: 'pointer',
    fontFamily: 'Poppins',
    color: '#00C99E',
  }

  return (
    <Card title="Summary" noDivider>
      <Grid container spacing={1} mt={1}>
        {/* Expected return row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Expected return</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={valueStyle}>
              {manAuthRequest?.expectedReturn
                ? new Date(manAuthRequest.expectedReturn).toLocaleDateString(navigator.language)
                : 'N/a'}
            </Paragraph>
          </Grid>
        </Grid>

        {/* Department row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Department</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={valueStyle}>{manAuthRequest?.departmentName}</Paragraph>
          </Grid>
        </Grid>

        {/* Line manager / Approver row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>{isManager ? 'Approver' : 'Line manager'}</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Paragraph style={valueStyle}>
              {isManager
                ? manAuthRequest?.approvedOrDeclinedByDisplayName ||
                  manAuthRequest?.assignedApproverDisplayName ||
                  NO_APPROVER_ASSIGNED
                : manAuthRequest?.managerDisplayName}

            </Paragraph>
          </Grid>
        </Grid>

        {/* Relating absence row */}
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Paragraph style={labelStyle}>Relating absence</Paragraph>
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <Link
              href="#"
              onClick={e => {
                e.preventDefault()
                navigate(`/myactions/absenceoccurrence/${manAuthRequest?.absenceId}`, {
                  state: {
                    previousLocation: window.location.pathname,
                    params: {},
                    originalPreviousLocation: location.state?.previousLocation || location.state?.originalPreviousLocation
                  }
                })
              }}
              style={linkStyle}
            >
              View absence
            </Link>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  )
}
